import { useState, useRef, useLayoutEffect, useEffect } from "react";
import { useTranslation } from "react-i18next";

export const PlanDesc = ({ desc }: { desc: string }) => {
  const { t } = useTranslation("enrollment");
  const [showMore, setShowMore] = useState(false);
  const [hasOverflow, setHasOverflow] = useState(false);
  const descRef = useRef<HTMLParagraphElement>(null);

  useLayoutEffect(() => {
    const el = descRef.current;
    if (!el) return;

    const checkOverflow = () => {
      const visible = el.clientHeight;
      const full = el.scrollHeight;
      setHasOverflow(full > visible + 0.5);
    };

    checkOverflow();
    window.addEventListener("resize", checkOverflow);
    return () => window.removeEventListener("resize", checkOverflow);
  }, [desc]);

  useEffect(() => {
    if (!hasOverflow && showMore) {
      setShowMore(false);
    }
  }, [hasOverflow, showMore]);

  if (!desc) return null;

  return (
    <div className="plan-desc-section">
      <span
        ref={descRef}
        className={`plan-desc ${showMore ? "active" : ""}`}
        dangerouslySetInnerHTML={{ __html: desc }}
      />
      {hasOverflow && (
        <span
          onClick={(e) => {
            e.preventDefault();
            setShowMore((v) => !v);
          }}
          className="plan-desc-toggle"
        >
          {showMore ? t("Hide") : t("Show More")}
        </span>
      )}
    </div>
  );
};
